import { formatMoneyPence } from '../lib/format';
import type { JobPricing } from '../types/models';

export function PriceSummary({pricing}: {pricing?: JobPricing | null}) {
  if (!pricing) return null;
  const format = (amount: number) => formatMoneyPence(amount, pricing.currency);
  return <dl className="space-y-2 rounded-[10px] bg-surface p-3 text-[14px]">
    <div className="flex justify-between gap-3 font-semibold"><dt>Total</dt><dd className="font-mono">{format(pricing.amountPence)}</dd></div>
    <div className="flex justify-between gap-3"><dt>Job</dt><dd className="font-mono">{pricing.breakdown ? format(pricing.breakdown.jobAmountPence) : 'Not itemised'}</dd></div>
    <div className="flex justify-between gap-3"><dt>Additional charges</dt><dd className="font-mono">{pricing.breakdown ? format(pricing.breakdown.charges.reduce((sum, line) => sum + line.amountPence, 0)) : 'Not itemised'}</dd></div>
  </dl>;
}
